import { Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useParams } from 'react-router'
import api from '../../../../components/services/api'


export default function ContainerInformation() {
    const { id } = useParams()
    const [data, setData] = useState([])

    const getData = async () => {
        const res = await api.get(`api/cargotracking/detail/${id}`)
        const data = await res.data.ContainerList
        setData(data)
    }
    useEffect(() => {
        getData()
    }, [])
    const columns = [
        { field: "ContainerNo", headerName: "Container No.", width: 200 },
        { field: "Gender", headerName: "Empty/Laden", width: 120 },
        { field: "LatestStatus", headerName: "Latest Status", width: 150 },
        { field: "Location", headerName: "Location", width: 200 },
    ]
    return (
        <Box
            sx={{
                height: 630,
                width: "100%",
                marginTop: "10px",
                // "& .Active": {
                //     color: "#28A745",
                // },
                // "& .Inactive": {
                //     color: "#F53C56",
                // },
            }}
        >
            <DataGrid
                getRowId={(r) => r.StockMovementID}
                rows={data}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                hideFooterSelectedRowCount
                disableColumnFilter
                disableColumnMenu
            // getCellClassName={(params) => {
            //     if (params.field === "Status") {
            //         return params.value == 1 ? "Active" : "Inactive";
            //     }
            // }}

            />
        </Box>
    )
}
